import defaults from './options';

function toStr(value) {
  return value ? value.toString() : '';
}

function onlyNumbers(input) {
  return toStr(input).replace(/\D+/g, '') || '0';
}

function between(min, n, max) {
  return Math.max(min, Math.min(n, max));
}

function fixed(precision) {
  return between(0, precision, 20);
}
function numbersToCurrency(numbers, precision) {
  const exp = 10 ** precision;
  const float = parseFloat(numbers) / exp;
  return float.toFixed(fixed(precision));
}

function addThousandSeparator(integer, separator) {
  return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${separator}`);
}

function joinIntegerAndDecimal(integer, decimal, separator) {
  return decimal ? integer + separator + decimal : integer;
}

function setCursor(el, position) {
  const setSelectionRange = function () { el.setSelectionRange(position, position); };
  if (el === document.activeElement) {
    setSelectionRange();
  }
}

function event(name) {
  const evt = document.createEvent('Event');
  evt.initEvent(name, true, true);
  return evt;
}

function format(input, opt = defaults) {
  if (opt.allowBlank && input === '') {
    return '';
  }

  let formattedInput = input;
  let customPrecision = opt.precision;

  if (typeof formattedInput === 'number') {
    const numStr = formattedInput.toString();
    const decimalParts = numStr.split('.');
    if (decimalParts.length > 1 && decimalParts[1].length > opt.precision) {
      customPrecision = decimalParts[1].length;
    }

    formattedInput = formattedInput.toFixed(fixed(customPrecision));
  } else if (typeof formattedInput === 'string') {
    const stringParts = formattedInput.split(opt.decimal);
    if (stringParts.length > 1 && stringParts[1].length > opt.precision) {
      customPrecision = stringParts[1].length;
    }
  }

  const negative = formattedInput.indexOf('-') >= 0 ? '-' : '';
  const numbers = onlyNumbers(formattedInput);

  const currency = numbersToCurrency(numbers, customPrecision);
  const parts = toStr(currency).split('.');
  let integer = parts[0];
  const decimal = parts[1];
  integer = addThousandSeparator(integer, opt.thousands);

  return opt.prefix + negative + joinIntegerAndDecimal(integer, decimal, opt.decimal) + opt.suffix;
}

function unformat(input, precision) {
  const negative = input.indexOf('-') >= 0 ? -1 : 1;
  const numbers = onlyNumbers(input);
  const currency = numbersToCurrency(numbers, precision);
  return parseFloat(currency) * negative;
}

export {
  format,
  unformat,
  setCursor,
  event,
};
